import api from 'plugin/api';
import { API_URL } from 'types/const';
import isJSON from 'utils/isJSON';
import jsonToFormData from 'utils/json/toFormData';
import format from 'utils/string/format';

/**
 * 자료실 목록 조회
 * @param {Object} params 요청 데이터
 * @param {string} params.keyword 제목 / 등록자
 * @param {number} [params.page=0] 페이지
 * @param {number} [params.size=20] 페이지당 최대 데이터 수
 * @return {Object} 응답 데이터
 */
async function requestList(params) {
  return api.get(API_URL.board.file.default, { params });
}

/**
 * 자료실 등록
 * @param {Object} data 요청 데이터
 * @param {string} data.title 제목
 * @param {File} data.files 첨부 파일
 * @param {string} data.content 내용
 * @return {Object} 응답 데이터
 */
async function requestInsert(data) {
  if (isJSON(data)) {
    data = jsonToFormData(data);
  }

  return api.post(API_URL.board.file.default, data, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
}

/**
 * 자료실 수정
 * @param {number} seq 자료실 번호
 * @param {Object} data 요청 데이터
 * @param {string} data.title 제목
 * @param {File} data.files 첨부 파일
 * @param {string} data.content 내용
 * @return {Object} 응답 데이터
 */
async function requestUpdate(seq, data) {
  if (isJSON(data)) {
    data = jsonToFormData(data);
  }

  return api.put(format(API_URL.board.file.inform, { seq }), data, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
}

/**
 * 자료실 삭제
 * @param {number} seq 자료실 번호
 * @return {Object} 응답 데이터
 */
async function requestDelete(seq) {
  return api.delete(format(API_URL.board.file.inform, { seq }));
}

/**
 * 자료실 정보 조회
 * @param {number} seq 자료실 번호
 * @return {Object} 응답 데이터
 */
async function requestInform(seq) {
  return api.get(format(API_URL.board.file.inform, { seq }));
}

/**
 * 첨부 파일 삭제
 * @param {Object} data 요청 데이터
 * @param {Object[]} data.fileAttachments 삭제할 첨부 파일 목록
 * @param {number} data.fileAttachments[].seq 첨부 파일 번호
 * @return {Object} 응답 데이터
 */
async function requestFileDelete(data) {
  return api.delete(API_URL.board.file.delete, { data });
}

/**
 * 첨부 파일 다운로드
 * @param {number} seq 첨부 파일 번호
 * @return {Object} 응답 데이터
 */
async function requestFileDownload(seq) {
  return api.get(format(API_URL.board.file.download, { seq }), {
    responseType: 'arraybuffer'
  });
}

export {
  requestList,
  requestInsert,
  requestUpdate,
  requestDelete,
  requestInform,
  requestFileDelete,
  requestFileDownload
};
